import { fallbackSiteSettings } from "../fallback/contentFallbacks";
import { mapSiteSettings } from "../mappers/wordpressMappers";
import { createServiceResult } from "./serviceResult";
import { fetchSiteSettings } from "../wordpress/wordpressApi";

export async function getSiteSettings(options = {}) {
  try {
    const response = await fetchSiteSettings(options);

    return createServiceResult({
      data: mapSiteSettings(response.data),
      source: "api",
    });
  } catch (error) {
    return createServiceResult({
      data: fallbackSiteSettings,
      source: "fallback",
      error,
      usedFallback: true,
    });
  }
}
